export const it_calendar= {
    title: 'Lista eventi',
    label_selection: 'Seleziona il calendario',
    label_not_authorized: 'Per accedere ai servizi di google calendar, devi effettuare l\'accesso a google.',
    label_request_authorized_button: 'Autenticazione Google'
}